// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"bcf03602","42":"249f5df9","48":"73d3f179","51":"53b6e313","136":"90b5b71a","354":"30d6297b","440":"86953158","525":"23eed8db","560":"24508028","569":"c0a59ba3","751":"1c3050c0","809":"4cc65d6d","897":"97ffeba5","912":"fdac8ee3"}[chunkId] + ".chunk.js";
};